import api from './authService';

/**
 * Public contact form - no auth required.
 */
export const contactService = {
  submit: async (data) => {
    const response = await api.post('/contact', {
      name: data.name,
      email: data.email,
      phone: data.phone || null,
      subject: data.subject,
      message: data.message,
      inquiryType: data.inquiryType || 'general',
    });
    return response.data;
  },
};
